import { IEmployeeTimeOffState } from '@/store/employee-timeoff';
import { IEmployeeTimeOffGetters } from './getters.types';
import {
  IEmployeeTimeOff,
  EmployeeTimeOff,
  EmployeeTimeOffBookingBalance,
  IEmployeeTimeOffBookingBalance,
  IEmployeeTimeOffEntitlement,
  EmployeeTimeOffEntitlement
} from '@/models';

export const getters: IEmployeeTimeOffGetters = {
  getEmployeeTimeOff(
    state: IEmployeeTimeOffState
  ): IEmployeeTimeOff | undefined {
    if (!state.employeeTimeOff) {
      return undefined;
    }
    return new EmployeeTimeOff(state.employeeTimeOff);
  },

  getEmployeeTimeOffBalances(
    state: IEmployeeTimeOffState
  ): IEmployeeTimeOffBookingBalance[] {
    return state.employeeTimeOffBalances.map(
      employeeTimeOffBalance =>
        new EmployeeTimeOffBookingBalance(employeeTimeOffBalance)
    );
  },

  getEmployeeTimeOffEntitlements(
    state: IEmployeeTimeOffState
  ): IEmployeeTimeOffEntitlement[] {
    return state.employeeTimeOffEntitlements.map(
      employeeTimeOffEntitlement =>
        new EmployeeTimeOffEntitlement(employeeTimeOffEntitlement)
    );
  },

  getEmployeeTimeOffEntitlementYears(state: IEmployeeTimeOffState): number[] {
    return state.employeeTimeOffEntitlementYears;
  },

  getEmployeeTimeOffEntitlementVacationYear(
    state: IEmployeeTimeOffState
  ): null | number {
    return state.employeeTimeOffEntitlementVacationYear;
  }
};
